import { type Configuration, LogLevel, PublicClientApplication } from "@azure/msal-browser";

const tenantId = import.meta.env.VITE_AZURE_TENANT_ID as string | undefined;
const clientId = import.meta.env.VITE_AZURE_CLIENT_ID as string | undefined;

if (!tenantId || !clientId) {
  // Em dev sem env, ainda permitimos o app carregar — mas o login falhará.
  // Mensagem dura aparece na tela Login.
  console.warn(
    "[msal] VITE_AZURE_TENANT_ID e/ou VITE_AZURE_CLIENT_ID não configurados. Configure em .env"
  );
}

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId ?? "00000000-0000-0000-0000-000000000000",
    authority: `https://login.microsoftonline.com/${tenantId ?? "common"}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) console.error(message);
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Scope nominal definido no App Registration (Expose an API → access_as_user).
// Pra MSAL chamando o próprio backend, Entra exige scope explícito (não `.default`).
export const apiScope = clientId ? `api://${clientId}/access_as_user` : "openid";

export const loginRequest = {
  scopes: ["openid", "profile", "email", apiScope],
};

export const msalInstance = new PublicClientApplication(msalConfig);
